import { jsx as a } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as e from "react";
import { forwardRef as f } from "react";
const c = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 5 20 20", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "currentColor", d: "m25.563 21.324-7.35-4.428a6.37 6.37 0 0 0 2.31-2.369 6.7 6.7 0 0 0 .857-3.258 6.5 6.5 0 0 0-1.433-4.1 6 6 0 0 0-3.637-2.156.83.83 0 0 0-.707.203.9.9 0 0 0-.227.312.9.9 0 0 0-.08.382v8.863a6.03 6.03 0 0 0-3.12-.909 6 6 0 0 0-3.137.85 6.27 6.27 0 0 0-2.683 3.346 6.58 6.58 0 0 0 .032 4.362.9.9 0 0 0 .203.328q.137.14.317.208a.84.84 0 0 0 .729-.068l7.35-4.427a6.7 6.7 0 0 0 .811 3.275 6.4 6.4 0 0 0 2.28 2.406 5.85 5.85 0 0 0 4.117.756 6.02 6.02 0 0 0 3.607-2.206.92.92 0 0 0 .184-.737.9.9 0 0 0-.144-.36.9.9 0 0 0-.275-.264z" })), l = /* @__PURE__ */ f(({ size: t = "inherit", sx: o, ...n }, r) => {
  const i = typeof o == "function" ? o : {
    fontSize: t,
    ...o
  };
  return /* @__PURE__ */ a(m, {
    ...n,
    ref: r,
    component: c,
    inheritViewBox: !0,
    sx: i
  });
});
l.displayName = "svg_fan";
export {
  l as default
};
